import { ChangeEvent, forwardRef, Ref } from "react";
import { Label, StyledTextArea, TextAreaContainer } from "./styled";

interface TextAreaProps {
  label?: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  "data-testid"?: string;
  id?: string;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  label,
  value,
  onChange,
  disabled,
  "data-testid": dataTestId,
  id,
  ...props
}, ref: Ref<HTMLTextAreaElement>) => {
  return (
    <TextAreaContainer>
      {label && <Label htmlFor={id}>{label}</Label>}
      <StyledTextArea
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        data-testid={dataTestId}
        {...props}
      />
    </TextAreaContainer>
  );
});

export default TextArea;
